import { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Tabs, Typography } from 'shared/ui'
import callingCnamCallerId from 'shared/assets/images/compliance/callingCnamCallerId.png'
import callingStirShaken from 'shared/assets/images/compliance/callingStirShaken.png'
import callingVoiceIntegrity from 'shared/assets/images/compliance/callingVoiceIntegrity.png'
import { getCDNAssetURL } from 'shared/lib'
import styles from './styles.module.scss'

const TAB_CONTENT = {
  voiceIntegrity: {
    label: 'Voice Integrity',
    description:
      'Share your brand and contact details with carriers to reduce the risk of being marked as spam.',
    image: callingVoiceIntegrity,
  },
  stirShaken: {
    label: 'STIR / SHAKEN',
    description:
      'Increase answer rates of your calls by showing “Caller Verified” and preventing “Spam Likely” labels.',
    image: callingStirShaken,
  },
  cnamCallerId: {
    label: 'CNAM Caller ID',
    description:
      'Add a caller ID that represents your business to build an instant connection with customers.',
    image: callingCnamCallerId,
  },
}

type IModalContentFirstStepProps = {
  countTitle: string
}

export const ModalContentFirstStep = observer(({ countTitle }: IModalContentFirstStepProps) => {
  const [activeTabKey, setActiveTabKey] = useState<keyof typeof TAB_CONTENT>('voiceIntegrity')
  const activeTab = TAB_CONTENT[activeTabKey]

  return (
    <div>
      <div className={styles.header}>
        <Typography ariaLabel='trustedCalling' variant='heading-lg'>
          Trusted Calling
        </Typography>
        <Typography ariaLabel='trustedCalling' variant='body-rg-regular'>
          {countTitle}
        </Typography>
      </div>

      <Tabs
        variant={'simple'}
        gap={8}
        tabsClassName={styles.tabs}
        activeTabKey={activeTabKey}
        handleSelectTab={(tab) => setActiveTabKey(tab.key as keyof typeof TAB_CONTENT)}
        tabs={Object.keys(TAB_CONTENT).map((key) => ({
          key,
          name: TAB_CONTENT[key as keyof typeof TAB_CONTENT].label,
        }))}
      />

      <Typography
        ariaLabel='trustedCalling'
        variant='body-rg-regular'
        color='var(--content-primary-tertiary)'
        marginTop='24px'
        marginBottom='24px'
        tag='div'
      >
        {activeTab.description}
      </Typography>

      <img src={getCDNAssetURL(activeTab.image)} alt={activeTabKey} className={styles.image} />
    </div>
  )
})
